import React from 'react';

interface PDFDownloadButtonProps {
  onClick: () => void;
  children?: React.ReactNode;
}

export const PDFDownloadButton: React.FC<PDFDownloadButtonProps> = ({ onClick, children }) => {
  return (
    <button className='btn-gpx' onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="28px"
        height="28px"
        style={{ marginRight: "8px" }}
      >
        <path
          fill="currentColor"
          d="M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3zm-1-4l-1.41-1.41L13 12.17V4h-2v8.17L8.41 9.59L7 11l5 5z"
        ></path>
      </svg>
      {children || 'GPX'}
    </button>
  );
}
